<app-page-container>
  <div class="container">
    <ng-lottie height="200px" [options]="options"></ng-lottie>
    <h2>Ops! Página não encontrada</h2>
    <button class="button-primary" appGoBack>Voltar</button>
  </div>
</app-page-container>